module.exports = __webpack_public_path__ + "static/img/lianmeng2.fe24ae0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xieyi/lianmeng2.jpg
// module id = 1417
// module chunks = 1